<ng-template componentFactory [config]="ckEditorConfig"></ng-template>
